"use strict";
var slide_component_1 = require('./carousel/slide.component');
var carousel_component_1 = require('./carousel/carousel.component');
var slide_component_2 = require('./carousel/slide.component');
exports.SlideComponent = slide_component_2.SlideComponent;
var carousel_component_2 = require('./carousel/carousel.component');
exports.CarouselComponent = carousel_component_2.CarouselComponent;
exports.CAROUSEL_DIRECTIVES = [carousel_component_1.CarouselComponent, slide_component_1.SlideComponent];



/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-bootstrap/components/carousel.js
 ** module id = 691
 ** module chunks = 0
 **/